interface ComingSoonProps {
  /** What's coming — e.g. "RFIs", "Schedule". */
  title: string;
  /** Optional one-line explanation of what will live here. */
  note?: string;
}

/**
 * Honest placeholder for a workspace tab whose data domain isn't built yet
 * (RFIs, Submittals, Daily Logs, Schedule, …). Keeps the chrome consistent
 * without fabricating data. Replaced per-tab as each overhaul phase lands.
 */
export default function ComingSoon({ title, note }: ComingSoonProps) {
  return (
    <div
      style={{
        background: '#fff',
        border: '1px solid var(--ew-n-200)',
        borderRadius: 'var(--ew-r-md)',
        padding: 'var(--ew-s-8) var(--ew-s-6)',
        textAlign: 'center',
      }}
    >
      <div style={{ font: 'var(--ew-fw-semibold) var(--ew-fs-h4)/1.2 var(--ew-font)', color: 'var(--ew-dark)' }}>
        {title}
      </div>
      <p style={{ margin: 'var(--ew-s-2) 0 0', font: 'var(--ew-fw-regular) var(--ew-fs-body-sm)/var(--ew-lh-body) var(--ew-font)', color: 'var(--ew-n-500)' }}>
        {note ?? 'This workspace is coming soon.'}
      </p>
    </div>
  );
}
